module.exports = __webpack_public_path__ + "static/media/poldisc_mocnaya_kartka.ed761093.doc";